import {
  DropDown,
  FormControls,
  InfoTooltip,
} from '@elementary/common-ui/components';
import { Tooltip } from '@mui/material';
import { Control, Controller, useWatch } from 'react-hook-form';
import { AddTestForm, TimestampFormField } from 'shared/types';
import { getNoTimestampColumnMessage } from 'testManagement/utils/wizardTimestampFields';

type Props = {
  title?: string;
  control: Control<AddTestForm, any>;
  options: { value: string; label: string }[];
  name?: TimestampFormField;
  placeholder?: string;
  isOptional?: boolean;
  emptyOptionLabel?: string;
  optionalHint?: string;
};

const TimestampColumnFormField = ({
  title = 'Provide timestamp column',
  control,
  options,
  name = 'timestampColumn',
  placeholder = 'Timestamp column',
  isOptional,
  emptyOptionLabel = 'No timestamp column',
  optionalHint,
}: Props) => {
  const dropDownOptions = isOptional
    ? [{ value: '', label: emptyOptionLabel }, ...options]
    : options;
  const selectedResources = useWatch({ control, name: 'resources' });
  const isDisabled = !options.length;
  const disabledReason = getNoTimestampColumnMessage(
    selectedResources?.length ?? 0,
    !isOptional,
  );

  return (
    <FormControls.Row>
      <FormControls.FormText>{title}:</FormControls.FormText>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Tooltip title={isDisabled ? disabledReason : ''}>
            <DropDown
              placeholder={isOptional ? emptyOptionLabel : placeholder}
              size="large"
              options={dropDownOptions}
              sortOptions={false}
              {...field}
              value={field.value ?? ''}
              disabled={isDisabled}
            />
          </Tooltip>
        )}
      />
      {isOptional && optionalHint && <InfoTooltip title={optionalHint} />}
    </FormControls.Row>
  );
};

export default TimestampColumnFormField;
